import { EyeClosedIcon, EyeOpenIcon } from "@/assets";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import StyledInputBase from "./StyledInputBase";

export default function InputLoginForm({
  placeholder,
  label,
  children,
  mt,
  password,
  value,
  main,
  showResetPassword = true,
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);
  const md = useMediaQuery("(max-width:450px)");

  return (
    <Box width={md ? "100%" : "300px"}>
      <Grid
        width={"100%"}
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
      >
        <Typography
          sx={{
            color: "var(--emr-text-light)",
            textAlign: "right",
            fontSize: "12px",
            mt: mt ? mt : "0",
            mb: "5px",
            display: "flex",
          }}
        >
          {label}
          {main && (
            <Typography color="red" mr="5px">
              *
            </Typography>
          )}
        </Typography>
        {password && showResetPassword && (
          <Link to="/forgetPassword">
            <Typography
              sx={{
                color: "var(--emr-primary)",
                textAlign: "right",
                fontSize: "12px",
                mt: mt ? mt : "0",
                mb: "5px",
                cursor: "pointer",
              }}
            >
              فراموشی رمز عبور
            </Typography>
          </Link>
        )}
      </Grid>
      <Box
        boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.08)"
        border="solid 1px #D7D7D7"
        gap="20px"
        padding="8px 16px"
        width="calc(100% - 32px)"
        borderRadius="8px"
        display="flex"
        alignItems="center"
      >
        {children}
        {!password && (
          <InputBase
            {...props}
            sx={{ width: "100%" }}
            placeholder={placeholder}
            value={value}
          />
        )}
        {password && (
          <StyledInputBase
            value={value}
            type={showPassword ? "text" : "password"}
            {...props}
            placeholder={placeholder}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                  aria-label={showPassword ? "مخفی کردن رمز" : "نمایش رمز"}
                >
                  {showPassword ? <EyeClosedIcon /> : <EyeOpenIcon />}
                </IconButton>
              </InputAdornment>
            }
          />
        )}
      </Box>
    </Box>
  );
}
